<template>
    <div class="video-wrap-wel">
        <div class="video-item-wrap">
            <div class="static-pic" @click="toPlay" v-if="!videoVisible">
                <img class="video-play" src="@/assets/imgs/video_play.png" alt="">
            </div>
            <div class="static-pic" v-if="videoVisible">
                <video-player v-if="videoVisible"
                    :width="width"
                    :height="height"
                    :video-details="coursesMessage"
                    :video-visible="videoVisible" />
            </div>
        </div>
    </div>
</template>
<script>
import VideoPlayer from '@/components/Video'
import { getVideoLink } from '@/api/video'
export default {
    name: 'videoShow',
    data () {
        return {
            videoVisible: false,
            width: '320px',
            height: '160px',
            videoKey: this.$route.params.videoKey,
            coursesMessage: {
                videoId: '',
                videoName: ''
            }
        }
    },
    components: {
        VideoPlayer
    },
    mounted () {
        if (this.videoKey) {
            this.getVideo()
        }
    },
    methods: {
        async getVideo () {
            const { state, results } = await getVideoLink(this.videoKey)
            if (state === 200 && results) {
                const { videoId, videoName } = results
                this.coursesMessage.videoId = videoId
                this.coursesMessage.videoName = videoName
            }
        },
        toPlay () {
            const { videoId } = this.coursesMessage
            if (videoId) {
                this.videoVisible = true
            } else {
                this.$message({
                    message: '该视频暂无法播放',
                    type: 'warning'
                })
            }
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scope>
.static-pic {
    width: 320px;
    height: 160px;
    margin: 0 auto;
    background: #666;
    cursor: pointer;
    .video-play {
        width: 40px;
        height: 40px;
        margin: 60px 0 0 140px;
    }
}
</style>
